var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottery-publicity-card-container"},_vm._l((_vm.numberList),function(item,index){return _c('transition',[_c('CommonCard',{key:index,attrs:{"dataForm":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }